import { Component, OnInit, Input } from '@angular/core';
import { SetService, EventService, HttpService, PageService } from 'ngx-block-core';
import { NzModalService, NzMessageService, NzNotificationService } from 'ng-zorro-antd';
import { eventType2, selectSize, selectThemeSize, iconTheme } from "../../../data/data";
import { Router } from '@angular/router';

@Component({
  selector: 'app-sucu05-button0010006',
  templateUrl: './sucu05-button0010006.component.html',
  styleUrls: ['./sucu05-button0010006.component.less'],

})
export class Sucu05Button0010006Component implements OnInit {

  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() isVisible = false;
  @Input() sets = {
    blockCode: "sucublock55",
    blockId: "",
    blockName: "收展按钮",
    layoutId: "",
    blockType: 'formButton',
    blockChildType: '',
    versionCode: 2,
    styles: {
      nzMode: "button",//icon|tag
      nzText: "收起",
      nzType: "default",
      nzSize: "default",
      nzBgColor: "",
      nzDefaultExpand: false,
      nzExpand: {
        nzText: "收起",
        nzType: "default",
        nzSize: "default",
      },
      nzNotExpand: {
        nzText: "展开",
        nzType: "default",
        nzSize: "default",
      },
      nzIcon: {
        nzIconType: 'up',
        nzIconTheme: '',
        nzIconColor: '',
      },
      nzOpen: true,
      nzConfirm: {
        nzShow: false,
        nzTitle: "提示",
        nzContent: "确定吗？"
      },
    },
    datas: {

    }
  };
  setData = []
  setDataInit() {
    this.setData = [
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'select',
                inputs: { nzText: "模式 : ", nzKeys: ['styles', 'nzMode'], 
                nzData: [ { value: "button", label: "按钮" },
                          { value: "icon", label: "图标" },
                          { value: "tag", label: "标签" }] },
              },
              {
                name: 'input',
                inputs: { nzText: "收文字 : ", nzKeys: ['styles', 'nzExpand','nzText'] }
              },
              {
                name: 'input',
                inputs: { nzText: "展文字 : ", nzKeys: ['styles', 'nzNotExpand','nzText'] }
              },
              {

                name: 'select',
                inputs: {
                  nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                }
              },

              {
                name: 'color',
                inputs: {
                  nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                }
              },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
              },
              {
                name: 'switch',
                inputs: { nzText: "默认展开 : ", nzKeys: ['styles', 'nzDefaultExpand'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "开放按钮 : ", nzKeys: ['styles', 'nzOpen'] }
              },
              { name: 'nzConfirm' }
            ]
          },
        ]
      },


    ]
  }




  constructor(
    public setService: SetService,
    public eventService: EventService,
    private message: NzMessageService,
    private modalService: NzModalService,
    private httpService: HttpService,
    private pageService: PageService,
    private notification: NzNotificationService


  ) { }
  formLayout = true;
  ngOnInit() {


    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.autoUpdate();
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }
        

      }
      else {//静态
        if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
        this.autoUpdate();
      }
    }
    if (typeof this.setService.pageDatas['form_' + this.layoutid] == 'undefined') {
      this.formLayout = false;
    }
    if (this.sets.styles.nzDefaultExpand)
      this.setService.pageDatas['expand_' + this.blockid] = true;
    else
      this.setService.pageDatas['expand_' + this.blockid] = false;
    console.log("收展", this.setService.pageDatas['expand_' + this.blockid])
  }

  autoUpdate() {

    if (this.sets.versionCode < 2) {

      this.sets.styles['nzMode'] = "button";

      this.sets.versionCode = 2;
  }
  }

  private nzTimer;
  nzLoading = false;
  endEvent = [];
  onClickEvents() {
    console.log("调用检测")
    this.setService.pageDatas['expand_' + this.blockid] = !this.setService.pageDatas['expand_' + this.blockid];
  }
  onClick(): void {
    if (!this.sets.styles.nzOpen) {
      this.message.create('info', `功能暂未开放`);
    } else {
      //判断是否控制条数限制
      if (this.sets.styles.nzConfirm.nzShow) {
        this.modalService.confirm({
          nzTitle: this.sets.styles.nzConfirm.nzTitle,
          nzContent: this.sets.styles.nzConfirm.nzContent,
          nzOnOk: () => this.onClickEvents()
        });
      }
      else {
        this.onClickEvents();
      }



    }

  }

}
